import axios from 'axios';

import { API_GEOLOCATION_URL, DEFAULT_COUNTRY } from '../config/constants';
import BffApiResponse from '../models/BffApiResponse';
import { StatusDataModel } from '../models/StatusDataModel';
import api from '../utils/axios';
import { formattingTitaskBffResponseErrors } from '../utils/utils';

const UtilService = {
  getLocalCountryFromApi: async (): Promise<string> => {
    try {
      const {
        data: { country: localCountry },
      } = await axios.get(API_GEOLOCATION_URL);
      return localCountry;
    } catch (error) {
      console.error(error);
      return DEFAULT_COUNTRY;
    }
  },

  getDataForStatusForCurrentUser: async (): Promise<BffApiResponse> => {
    try {
      const response = await api.get(
        `/user-utility/get-titask-data-for-status-by-current-user`
      );
      const responseData = response.data.data;
      return new BffApiResponse(true, responseData as StatusDataModel);
    } catch (err) {
      return formattingTitaskBffResponseErrors(err);
    }
  },
};

export default UtilService;
